import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const Hint = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  color: ${Colors.Neutral50};
`
